import { render } from "./TrendSparkline.vue?vue&type=template&id=04fbe10a&ts=true"
import script from "./TrendSparkline.vue?vue&type=script&lang=ts"
export * from "./TrendSparkline.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__